import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _573314a1 = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _c6114ca2 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _09f264a2 = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _1038857c = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _aaf47310 = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _1c05433f = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _6f73654b = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _2bb05f9e = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _71d22c11 = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _11d71e87 = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _73963088 = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _250d7f3c = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _5dcba1e7 = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _2bc7a884 = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _6fafbb41 = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _28bc6714 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _b777a834 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _2076e5e1 = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _573314a1,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _c6114ca2,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _09f264a2,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _1038857c,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _aaf47310,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _1c05433f,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _1c05433f,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _1c05433f,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _6f73654b,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _2bb05f9e,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _71d22c11,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _2bb05f9e,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _71d22c11,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _11d71e87,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _11d71e87,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _11d71e87,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _11d71e87,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _11d71e87,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _11d71e87,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _11d71e87,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _73963088,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _73963088,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _250d7f3c,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _5dcba1e7,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _5dcba1e7,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _2bc7a884,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _6fafbb41,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _28bc6714,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _28bc6714,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _b777a834,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _2076e5e1,
    name: "appDownload"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
